import { useNavigate } from 'react-router-dom';
import { AdminShell } from './AdminShell.jsx';
import { useSuperAdminAuth } from '../../auth/SuperAdminAuthContext.jsx';

const NAV_ITEMS = [{ to: '/super-admin/tenants', label: 'Tenants', icon: 'restaurant', end: false }];

export function SuperAdminShell() {
  const { identity, logout } = useSuperAdminAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate('/super-admin/login', { replace: true });
  }

  return <AdminShell brand="Platform Admin" navItems={NAV_ITEMS} onLogout={handleLogout} identityLabel={identity?.email} />;
}
